import { c as _c } from "react/compiler-runtime";
import { FormInput, InputProps } from '@systemeio/ui';
import { ChangeEvent, ForwardedRef, forwardRef } from 'react';
import { Controller, ControllerProps, FieldPath, FieldValues, PathValue, UseFormSetValue } from 'react-hook-form';
type FormInputRhfProps<TValues extends FieldValues, TName extends FieldPath<TValues>> = InputProps & Omit<ControllerProps<TValues, TName>, 'render'> & {
  setValue: UseFormSetValue<TValues>;
};
function FormInputRhfBase(props, ref) {
  const $ = _c(18);
  let control;
  let name;
  let restProps;
  let rules;
  let setValue;
  if ($[0] !== props) {
    ({
      setValue,
      control,
      name,
      rules,
      ...restProps
    } = props);
    $[0] = props;
    $[1] = control;
    $[2] = name;
    $[3] = restProps;
    $[4] = rules;
    $[5] = setValue;
  } else {
    control = $[1];
    name = $[2];
    restProps = $[3];
    rules = $[4];
    setValue = $[5];
  }
  let t0;
  if ($[6] !== name || $[7] !== setValue) {
    t0 = event => setValue(name, event.target.value as PathValue<TValues, TName>);
    $[6] = name;
    $[7] = setValue;
    $[8] = t0;
  } else {
    t0 = $[8];
  }
  const handleChange = t0;
  let t1;
  if ($[9] !== handleChange || $[10] !== ref || $[11] !== restProps) {
    t1 = t2 => {
      const {
        field
      } = t2;
      return <FormInput {...restProps} ref={ref} value={field.value} onChange={handleChange} />;
    };
    $[9] = handleChange;
    $[10] = ref;
    $[11] = restProps;
    $[12] = t1;
  } else {
    t1 = $[12];
  }
  let t2;
  if ($[13] !== control || $[14] !== name || $[15] !== rules || $[16] !== t1) {
    t2 = <Controller control={control} name={name} rules={rules} render={t1} />;
    $[13] = control;
    $[14] = name;
    $[15] = rules;
    $[16] = t1;
    $[17] = t2;
  } else {
    t2 = $[17];
  }
  return t2;
}
const FormInputRhf = forwardRef(FormInputRhfBase) as <TValues extends FieldValues, TName extends FieldPath<TValues>>(props: FormInputRhfProps<TValues, TName> & {
  ref?: ForwardedRef<HTMLInputElement>;
}) => ReturnType<typeof FormInputRhfBase>;
export default FormInputRhf;